(() => {

  function init(root) {
    if (root.dataset.ucwCartInitialised) return;
    root.dataset.ucwCartInitialised = 'true';
    const config = JSON.parse(root.dataset.ucwCartConfig);
    const {sectionId, moneyFormat, formId, currency, cartUrl, cartChangeUrl, cartUpdateUrl} = config;
    const sectionSelector = '#uw-main-cart-' + sectionId;
    let busy = false;
    function showError(error) {
      const section = getSection(); if (!section) return;
      let alert = section.querySelector('[data-ucw-main-cart-error]');
      if (!alert) { alert = document.createElement('p'); alert.dataset.ucwMainCartError = ''; alert.className = 'ucw-main-cart-error'; alert.setAttribute('role','alert'); section.prepend(alert); }
      alert.textContent = error.message || 'Uw winkelwagen kon niet worden bijgewerkt. Vernieuw de pagina en probeer opnieuw.';
    }
    async function cartFetch(url, options = {}) {
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(15000), ...options});
      if (!response.ok) { let data; try { data = await response.clone().json(); } catch {} throw new Error(data?.description || 'Uw winkelwagen kon niet worden bijgewerkt. Vernieuw de pagina en probeer opnieuw.'); }
      return response;
    }
    function onAction(type, handler) {
      document.addEventListener(type, async event => {
        if (!event.target.closest(sectionSelector)) return;
        if (type === 'click' && !event.target.closest('[data-uw-main-cart-qty-minus],[data-uw-main-cart-qty-plus],[data-uw-main-cart-remove],[data-uw-main-cart-group-remove],.remove-discount,[data-cart-volume-qty]')) return;
        if (type === 'change' && !event.target.matches('[data-uw-main-cart-qty-input]')) return;
        if (busy) {event.preventDefault(); return;}
        busy = true; getSection()?.setAttribute('aria-busy','true');
        try {await handler(event);} catch(error) {showError(error);}
        finally {busy = false; getSection()?.removeAttribute('aria-busy');}
      });
    }

    function getSection() {
      return document.querySelector(`#uw-main-cart-${sectionId}`);
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    async function getCart() {
      const response = await cartFetch(cartUrl + '.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    }

    async function updateHeaderCartCount() {
      const cart = await getCart();

      document.querySelectorAll('#cart-count, .uw-main-header__cart-count').forEach((el) => {
        el.textContent = cart.item_count;
      });

      document.querySelectorAll('.uw-main-header__cart').forEach((el) => {
        el.setAttribute('aria-label', `Winkelwagen ${cart.item_count} artikel(en)`);
      });
    }

    async function refreshMainCartHtml() {
      const oldSection = getSection();
      if (!oldSection) return;

      const response = await cartFetch(`${window.location.pathname}?section_id=${sectionId}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.querySelector(`#uw-main-cart-${sectionId}`);

      if (!newSection) throw new Error('Uw winkelwagen is bijgewerkt, maar de weergave kon niet worden vernieuwd. Vernieuw de pagina.');
      const active = document.activeElement; const activeId = oldSection.contains(active) ? active.id : '';
      oldSection.innerHTML = newSection.innerHTML;
      if (activeId) document.getElementById(activeId)?.focus({preventScroll:true});
      syncLeverdatumFields();

      if (typeof window.initGiftSection === 'function') {
        oldSection.querySelectorAll('[data-gift-section-wrapper]').forEach((giftSection) => {
          giftSection.removeAttribute('data-gift-initialized');
          window.initGiftSection(giftSection);
        });
      }
    }

    async function changeCartLine(line, quantity) {
      const response = await cartFetch(cartChangeUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        })
      });

      if (!response.ok) throw new Error('Cart update failed');

      await refreshMainCartHtml();


      await updateHeaderCartCount();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    onAction('click', async (event) => {
      const section = event.target.closest(`#uw-main-cart-${sectionId}`);
      if (!section) return;

      const minus = event.target.closest('[data-uw-main-cart-qty-minus]');
      const plus = event.target.closest('[data-uw-main-cart-qty-plus]');
    const remove = event.target.closest('[data-uw-main-cart-remove]');
    const removeDiscount = event.target.closest('.remove-discount');

const groupRemove = event.target.closest('[data-uw-main-cart-group-remove]');

if (groupRemove) {
  event.preventDefault();

  const item = groupRemove.closest('.uw-main-cart__item');
  const keys = (item?.getAttribute('data-group-keys') || '')
    .split(',')
    .filter(Boolean);

  if (!keys.length) return;

  const updates = {};
  keys.forEach((key) => {
    updates[key] = 0;
  });

  await cartFetch(cartUpdateUrl + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates })
  });

  await refreshMainCartHtml();
  await updateHeaderCartCount();
  document.dispatchEvent(new CustomEvent('cart:updated'));
  return;
}

if (removeDiscount) {
  event.preventDefault();

  await cartFetch(cartUpdateUrl + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      discount: ''
    })
  });

  await refreshMainCartHtml();
  await updateHeaderCartCount();

  document.dispatchEvent(new CustomEvent('cart:updated'));
  return;
}


const cartVolumeButton = event.target.closest('[data-cart-volume-qty]');

if (cartVolumeButton) {
  event.preventDefault();

  if (cartVolumeButton.disabled) return;

  const line = cartVolumeButton.getAttribute('data-line');
  const quantity = cartVolumeButton.getAttribute('data-cart-volume-qty');

  if (!line || !quantity) return;

  await changeCartLine(line, quantity);
  return;
}


if (minus || plus) {
  event.preventDefault();

  const button = minus || plus;
  const line = button.getAttribute('data-line');
  const input = section.querySelector(`[data-uw-main-cart-qty-input][data-line="${line}"]`);
  const item = button.closest('.uw-main-cart__item');

  if (!input || !item) return;

  const step = Number(input.getAttribute('step') || 1);
  const current = Number(input.value || 0);
  const min = Number(input.getAttribute('min') || 1);
  const max = Number(input.getAttribute('max') || 0);

  let nextTotal = plus ? current + step : current - step;

  if (!plus) nextTotal = Math.max(0, nextTotal);
  if (plus && max > 0) nextTotal = Math.min(max, nextTotal);
  if (nextTotal > 0) nextTotal = Math.max(min, nextTotal);

  const paidKeys = (item.getAttribute('data-group-paid-keys') || '').split(',').filter(Boolean);
  const freeKeys = (item.getAttribute('data-group-free-keys') || '').split(',').filter(Boolean);

  if (paidKeys.length || freeKeys.length) {
    const freeQty = Math.floor(nextTotal / 4);
    const paidQty = nextTotal - freeQty;

    const updates = {};

    if (freeKeys.length) {
      paidKeys.forEach((key, index) => {
        updates[key] = index === 0 ? paidQty : 0;
      });

      freeKeys.forEach((key, index) => {
        updates[key] = index === 0 ? freeQty : 0;
      });
    } else {
      paidKeys.forEach((key, index) => {
        updates[key] = index === 0 ? nextTotal : 0;
      });
    }

    await cartFetch(cartUpdateUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    await refreshMainCartHtml();
    await updateHeaderCartCount();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return;
  }

  await changeCartLine(line, nextTotal);
  return;
}

      if (remove) {
        event.preventDefault();

        await changeCartLine(remove.getAttribute('data-line'), 0);
      }
    });

onAction('change', async (event) => {
  const input = event.target.closest(`#uw-main-cart-${sectionId} [data-uw-main-cart-qty-input]`);
  if (!input) return;

  const item = input.closest('.uw-main-cart__item');
  if (!item) return;

  const quantity = Number(input.value || 0);

  const min = Number(input.getAttribute('min') || 1);
  const max = Number(input.getAttribute('max') || 0);

  let nextTotal = quantity;

  if (nextTotal > 0) nextTotal = Math.max(min, nextTotal);
  if (max > 0) nextTotal = Math.min(max, nextTotal);

  const paidKeys = (item.getAttribute('data-group-paid-keys') || '').split(',').filter(Boolean);
  const freeKeys = (item.getAttribute('data-group-free-keys') || '').split(',').filter(Boolean);

  if (paidKeys.length || freeKeys.length) {
    const freeQty = Math.floor(nextTotal / 4);
    const paidQty = nextTotal - freeQty;

    const updates = {};

    if (freeKeys.length) {
      paidKeys.forEach((key, index) => {
        updates[key] = index === 0 ? paidQty : 0;
      });

      freeKeys.forEach((key, index) => {
        updates[key] = index === 0 ? freeQty : 0;
      });
    } else {
      paidKeys.forEach((key, index) => {
        updates[key] = index === 0 ? nextTotal : 0;
      });
    }

    await cartFetch(cartUpdateUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    await refreshMainCartHtml();
    await updateHeaderCartCount();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return;
  }

  await changeCartLine(input.getAttribute('data-line'), nextTotal, { showUndo: nextTotal === 0 });
});

onAction('submit', async (event) => {
  const form = event.target.closest(`#uw-main-cart-${sectionId} [data-uw-discount-form]`);
  if (!form) return;

  event.preventDefault();

  const input = form.querySelector('input[name="discount"]');
  const code = input?.value?.trim();

  if (!code) return;

  await cartFetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`, {
    credentials: 'same-origin'
  });

  input.value = '';

  await refreshMainCartHtml();
  await updateHeaderCartCount();

  document.dispatchEvent(new CustomEvent('cart:updated'));
});

function getVisibleLeverdatumBlock() {
  const isMobile = window.matchMedia('(max-width: 990px)').matches;

  return document.querySelector(
    isMobile
      ? `#uw-main-cart-${sectionId} .cart-leverdatum[data-leverdatum-block="mobile"]`
      : `#uw-main-cart-${sectionId} .cart-leverdatum[data-leverdatum-block="desktop"]`
  );
}

function syncLeverdatumFields() {
  const visibleBlock = getVisibleLeverdatumBlock();

  document.querySelectorAll(`#uw-main-cart-${sectionId} .cart-leverdatum`).forEach((block) => {
    const isActive = block === visibleBlock;

    const dateInput = block.querySelector('input[name="attributes[uiterlijk_nodig_op]"]');
    const noteInput = block.querySelector('textarea[name="attributes[opmerking_levering]"]');

    if (dateInput) {
      dateInput.disabled = !isActive;
      dateInput.required = isActive;
    }

    if (noteInput) {
      noteInput.disabled = !isActive;
    }
  });
}

function validateLeverdatumBeforeCheckout(event) {
  syncLeverdatumFields();

  const visibleBlock = getVisibleLeverdatumBlock();
  if (!visibleBlock) return true;

  const dateInput = visibleBlock.querySelector('input[name="attributes[uiterlijk_nodig_op]"]');
  if (!dateInput) return true;

  if (!dateInput.checkValidity()) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    dateInput.reportValidity();
    dateInput.focus();

    return false;
  }

  return true;
}

document.addEventListener('DOMContentLoaded', syncLeverdatumFields);
window.addEventListener('resize', syncLeverdatumFields);
window.addEventListener('orientationchange', syncLeverdatumFields);

document.addEventListener('click', function(event) {
  const checkoutButton = event.target.closest(`#uw-main-cart-${sectionId} button[name="checkout"]`);
  if (!checkoutButton) return;
  if (busy) {event.preventDefault(); event.stopImmediatePropagation(); return;}

  validateLeverdatumBeforeCheckout(event);
}, true);

document.addEventListener('submit', function(event) {
  const form = event.target.closest('#' + formId);
  if (!form) return;

  validateLeverdatumBeforeCheckout(event);
}, true);

syncLeverdatumFields();
    window.UcwMainCart = {refresh: async () => {await refreshMainCartHtml(); await updateHeaderCartCount(); document.dispatchEvent(new CustomEvent('cart:updated'));}};

  }
  const scan = () => document.querySelectorAll('[data-uw-main-cart][data-ucw-cart-config]').forEach(init);
  scan(); document.addEventListener('shopify:section:load', scan);

})();

